const EducationMapRenderer = () => (<></>);

const Color = {
    green: "rgb(140,217,46,0.8)",
    yellow: "rgb(255,207,6,0.8)",
    orange: "rgb(255,118,19,0.8)",
    red: "rgb(255,29,34,0.8)",
    blue: "rgb(54,91,218,0.8)",
    lightBlue: "rgb(172,172,255,0.8)",
    purple: "rgb(120,9,205,0.8)"
};

const getEduColor = (type) => {
    switch (type) {
        case "ACADEMY":
        case "ACADEMY_STREET":
            return "#FF5252";
        case "MIDDLE_SCHOOL":
            return "#00C853";
        case "ELEMENTARY_SCHOOL":
            return "#FFD740";
        default:
            return "#fff"
    }
};

const getAcademyStreetStyle = (count) => {
    if (!count || count < 20)
        return `left:-50%;padding:8px;color:${Color.lightBlue};`;
    else if (count < 50)
        return `left:-50%;padding:12px;color:${Color.green};`;
    else if (count < 100)
        return `left:-50%;padding:16px;color:${Color.yellow};`;
    else if (count < 200)
        return `left:-50%;padding:24px;color:${Color.orange};`;
    else
        return `left:-50%;padding:32px;color:${Color.red};`;
};

const getMiddleSchoolColor = (score) => {
    if (!score || score < 85)
        return Color.green;
    else if (score < 90)
        return Color.yellow;
    else if (score < 95)
        return Color.orange;
    else
        return Color.red;
};

const getElementarySchoolColor = (headcount) => {
    if (!headcount || headcount < 756)
        return Color.green;
    else if (headcount < 828)
        return Color.yellow;
    else if (headcount < 900)
        return Color.orange;
    else
        return Color.red;
};

const getEduMarker = (data) => {
    switch (data.type) {
        case "ACADEMY":
        case "ACADEMY_STREET":
            return {
                content: [
                    `<div style="position:relative;background:rgba(0,0,0,0.8);font-size:14px;border-radius:128px;${getAcademyStreetStyle(data.academyCount || data.count)};">`,
                    data.academyCount || data.count,
                    "개",
                    "</div>"
                ].join("")
            }
        case "MIDDLE_SCHOOL":
            return {
                content: [
                    `<div style="background:${getMiddleSchoolColor(data.score)};border-radius:4px;padding:10px;line-height:1em;margin-left:-30px;margin-top:-25px;">`,
                    data.name,
                    "<br/>",
                    data.score,
                    "/",
                    data.specializedHeadcount,
                    "</div>"
                ].join("")
            }
        case "ELEMENTARY_SCHOOL":
            return {
                content: [
                    `<div style="background:${getElementarySchoolColor(data.headcount)};border-radius:50px;padding:10px;line-height:1em;margin-left:-30px;margin-top:-25px;">`,
                    data.name,
                    "<br/>",
                    data.headcount,
                    "명",
                    "</div>"
                ].join("")
            }
        default:
            return null;
    }
};

export {
    EducationMapRenderer,    
    getEduColor,
    getEduMarker,
    getElementarySchoolColor,
    getMiddleSchoolColor
};
